var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowActiveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.961,
    height: 11.267,
    viewBox: "0 0 7.961 11.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M1809.036,4372.608a1,1,0,0,1-.633-.227l-6.327-5.186,6.3-5.6a1,1,0,1,1,1.329,1.494l-4.547,4.044,4.516,3.7a1,1,0,0,1-.635,1.773Z",
    transform: "translate(-1802.076 -4361.342)",
    fill: "#1b232a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowActiveLeft);
export default __webpack_public_path__ + "static/media/ArrowActiveLeft.87ed818804aaff0cad8630a382956e64.svg";
export { ForwardRef as ReactComponent };